import { DialogUI } from './dialogUI';
​
export enum DialogSize {
    small, // not in use
    default,
    large
}
​
export enum DialogTheme {
  default,
  danger
}

export class Dialog {
    protected ui: DialogUI;
    protected onConfirm: () => void;
    protected onCancel: () => void;
​
    public constructor() {
        this.ui = new DialogUI(this);
    }
​
    public withTitle(title: string): Dialog {
        this.ui.setTitle(title);
        return this;
    }
​
    public withText(text: string): Dialog {
        this.ui.setText(text);
        return this;
    }

    public withHTML(html: string): Dialog {
        this.ui.setHTML(html);
        return this;
    }
​
    public withTheme(theme: DialogTheme) {
      this.ui.setTheme(theme);
      return this;
    }

    public withCenteredContent() {
      this.ui.setCenter();
      return this;
    }

    public withIcon(iconName?: string): Dialog {
      if (iconName) {
        this.ui.setIcon(iconName);
      } else {
        this.ui.setIcon('brand-icons');
      }
      return this;
    }

    public withConfirmButtonText(text: string): Dialog {
        this.ui.setConfirmButtonText(text);
        return this;
    }

    public withCancelButtonText(text: string): Dialog {
        this.ui.setCancelButtonText(text);
        return this;
    }

    public withOnConfirm(callback: () => void): Dialog {
        this.onConfirm = callback;
        return this;
    }

    public withOnCancel(callback: () => void): Dialog {
        this.onCancel = callback;
        return this;
    }

    public withSize(size: DialogSize): Dialog {
        this.ui.setSize(size);
        return this;
    }

    public withoutButtons(): Dialog {
        this.ui.setHideButtons();
        return this;
    }

    public render(): Promise<any> {
        return new Promise((resolve) => {
            this.ui.render();
            this.afterRender();
            resolve();
        });
    }

    /**
     * will fuck up the ui
     */
    public close() : void {
        this.ui.destroy();
    }

    protected afterRender(): void {
        this.ui.bind(this.handleConfirm.bind(this), this.handleCancel.bind(this));
    }

    protected handleConfirm(): void {
        if (this.onConfirm !== undefined) {
            this.onConfirm();
        }
        this.destroy();
    }

    protected handleCancel(): void {
        if (this.onCancel !== undefined) {
            this.onCancel();
        }
        this.destroy();
    }

    protected destroy(): void {
        this.ui.destroy();
    }
}
